import { SignedIn, useUser } from "@clerk/clerk-react";
import { Navigate, Outlet } from "react-router-dom";
import { Bounce, ToastContainer } from "react-toastify";
import NotificationSlider from "../components/Notifications/NotificationSlider";
import LeftNav from "../components/leftNav/LeftNav";
import MobileNav from "../components/mobileNav/MobileNav";
import EditDeviceModal from "../components/modals/deviceDetailModal/EditDeviceModal";
import PageHeader from "../components/pageHeader/PageHeader";
import { PAGES } from "../constants/pages";
import { useAppContext } from "../context/AppContext";
import { useDeviceSettingsContext } from "../context/DeviceSettingsContext";
import NotificationMessage from "../components/Notifications/NotificationMessage";

const Layout = () => {
  const { isSignedIn, isLoaded } = useUser();
  const { notificationSliderVisible } = useAppContext();
  const { isDeviceModalOpen } = useDeviceSettingsContext();

  if (isLoaded && !isSignedIn) {
    return <Navigate to={PAGES.LOGIN} />;
  }

  return (
    <SignedIn>
      <div className="flex h-screen w-screen bg-gray-100">
        <NotificationMessage />
        <LeftNav />
        {/* Main Content */}
        <main className="overflow-auto relative w-full">
          <MobileNav />
          <div className="flex-1 p-4 md:p-8">
            <PageHeader />
            <Outlet />
            {isDeviceModalOpen && <EditDeviceModal onClose={() => {}} />}
          </div>

          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
          />
        </main>
        {notificationSliderVisible && <NotificationSlider />}
      </div>
    </SignedIn>
  );
};

export default Layout;
